import { screenSizes } from '@shipt/design-system-themes'
import styled from 'styled-components'

export const SprinklrForm = () => {
  return (
    <Container>
      <FormFrame
        id="sprinklr-contact-form"
        title="Website Contact Form"
        width="100%"
        height="100%"
        src="https://forms-prod2.sprinklr.com/guided-workflows/64f1bed7f6c9e950981c7685?gwId=428622"
      />
    </Container>
  )
}

const Container = styled.div`
  margin: 1.4rem auto;
  width: 100%;

  @media ${screenSizes.tablet} {
    max-width: 43.75rem;
  }
`

const FormFrame = styled.iframe`
  border: none;
  overflow: auto;
  min-height: 43.75rem;

  @media ${screenSizes.tablet} {
    aspect-ratio: 1 / 1;
  }
`
